<template>
  <li class="nav-item" v-if="googleOauthConnected">
    <a class="nav-link" href="#" @click.prevent="logout">Se déconnecter</a>
  </li>
  <li class="nav-item" v-else >
    <a class="nav-link" href="#" @click.prevent="login">Se connecter</a>
  </li>


  <li class="nav-item" v-if="googleOauthConnected" style="color: green" >
    <span class="nav-link">Connecté</span>
  </li>
  <li class="nav-item" v-else style="color: red" >
    <span class="nav-link">Pas connecté</span>
  </li>
</template>

<script>
  // Vuex
  import { googleOAuthUrl, googleOauthConnected, googleOAuthToken } from 'src/vuex/getters'
  import { login, logout, checkTokenFromSession } from 'src/vuex/actions/googleActions'

  export default{
    vuex: {
      getters: { googleOAuthUrl, googleOauthConnected, googleOAuthToken },
      actions: { login, logout, checkTokenFromSession }
    },
    data () {
      return {}
    },
    methods: {
      login: () => this.login(),
      logout: () => this.logout()
    },
    ready () {
      this.checkTokenFromSession()
    }
  }
</script>


<style lang="scss" >

</style>



// WEBPACK FOOTER //
// Login.vue?840fa9ac